<template>
    <div class="register-flow-wrap">
		<!-- <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading> -->
		<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
        <div class="row h-100 d-flex justify-content-center">
          <div class="col-4 pr-0">
            <div class="grayBox mb-2 py-3 px-2"> 
               <div class="processingBar d-flex align-items-center mb-3">
                  <div class="set-size charts-container mr-3"> 
                    <div class="pie-wrapper progress-45 style-2">
                      <vue-circle
                          :progress=userCstep*16.67
                          :size="60"
                          :reverse="false"
                          line-cap="round"
                          :fill="fill"
                          empty-fill="rgba(0, 0, 0, .1)"
                          :animation-start-value="0.0"
                          :start-angle="135"
                          insert-mode="append"
                          :thickness="3"
                          :show-percent="true"
                          ref="completeCircle"
                          >
                            <!-- <p>Slot!</p> -->
                      </vue-circle>
                      
                      <!-- <span class="label">{{getCurrentSteps()*20}}<span class="smaller">%</span></span>
                      <div class="pie">
                        <div class="left-side half-circle"></div>
                        <div class="right-side half-circle"></div>
                      </div>
                      <div class="leftshadow"></div> -->
                    </div> 
                  </div>
                  <div class="pieText">
                    <p> {{$t('fewStepAway')}}</p>
                    <h3> {{$t('activateFxviewAccountNow')}}</h3>
                  </div>
               </div>
               <div class="setUpFxaccount">
                  <div class="icotitle mb-3" :class="setUpFxaccount?'active':' '">
                    <h3 class="tbIn-mob" @click="setUpFxaccount = !setUpFxaccount">
                      <span class="untitled">
                      <img src="../../../../static/fxView/images/steps.svg" alt="">
                       {{$t('setupFxViewAcc')}}
                       </span>
                       <span class="clickView">
                        <feather type="chevron-down"></feather>
                       </span>  
                    </h3>
                  </div>
                  <ul class="stepListing">
                    <li v-for="(cnt, key) in steps" :class="(parseInt(get_user.step)+1 == key+1?'active' : '') || (tillCompletedTask(key)? 'complete' : '')" @click="getBacktoStep(key)">
                      <div class="left">
                        <i class="ico">{{key+1}}</i>
                        {{cnt}}
                      </div>
                      <span class="currentstep" ><feather type="check"></feather></span>
                      <span class="modify" @click.stop="modifyStep(key)" v-if="(tillCompletedTask(key) && parseInt(get_user.profile.ipv_status))"> View</span>
                      <span class="modify" @click.stop="modifyStep(key)" v-if="(tillCompletedTask(key) && !(parseInt(get_user.profile.ipv_status)))"> {{$t('modify')}}</span>
                    </li>
                  </ul>
               </div> 
             </div>
			
             <div class="grayBox py-3 px-2 mb-2 hideForMob">
               <div class="setUpFxaccount  py-0">
                  <div class="icotitle">
                    <h3>
                      <img src="../../../../static/fxView/images/add_funds.svg" alt="">
                       {{$t('addFund')}}
                    </h3>
                  </div>
               </div>
             </div>
             <div class="grayBox py-3 px-2 mb-2 hideForMob">
               <div class="setUpFxaccount  py-0">
                  <div class="icotitle">
                    <h3>
                      <img src="../../../../static/fxView/images/start_trading.svg" alt="">
                       {{$t('startTrading')}}
                    </h3>
                  </div>
               </div>
             </div>
          </div>
          <div class="col-8"> 
              <div class="grayBox h-100" v-if="get_user.fresh_user || openDemoAccount">
                <app-register-steps ></app-register-steps>  
              </div>
              <div class="h-100" v-else>
                <div class="congrtsMessage mb-2 d-flex align-items-center">
                  <div class="desc">
                    <h2> {{$t('welcomeFxView')}}</h2>
                    <p class="mb-3"> {{$t('welFxviewCon')}}</p>

                    <a href="#" class="btn_xs grd_btn" @click="getBacktoStep(getCurrentSteps())"> {{$t('completeReg')}} </a>
                  </div>
                  <div class="wlcthumb"> 
                    <img src="../../../../static/fxView/images/platform.svg" alt="" class="platfromThumb">

                  </div>
                </div>
                <div class="grayBox p-4 greybox-height">
                  <div class="innerTitle pb-3 mb-3 border-bottom">
                    <h2> {{$t('tryDemoAcc')}}</h2>
                  </div>
                  <div class="d-flex createDemoBox align-items-center py-3 mb-4">
                      <p class="w-75 pr-sm-5 mb-xs-3"> {{$t('tryDemoAccCon')}}</p>
                      <router-link :to="'/create-demo-account'" class="prism_btn btn_sm darkBG"> {{$t('createDemoAccount')}}</router-link>
                  </div>
                  <div class="innerTitle pb-3 mb-3 border-bottom">
                     <h2> {{$t('downloadPlatform')}}</h2>
                  </div>
                  <div class="downloadPlatform indexplatformdownload d-flex align-items-center ">
                    <div class="dpBox d-flex align-items-center">
                      <router-link to="/download-platform">
                        <div class="ico">
                          <img src="../../../../static/fxView/images/platforn-icon-1.svg" alt="">
                        </div>
                        <div class="desc">
                          <h4>{{$t('MT4')}}</h4>
                          <p>{{$t('winIosAndroid')}}</p>
                        </div>
                      </router-link>
                    </div> 
                    <!-- <div class="dpBox d-flex align-items-center">
                      <router-link to="/download-platform">
                        <div class="ico">
                          <img src="../../../../static/fxView/images/platforn-icon-3.svg" alt="">
                        </div>
                        <div class="desc">
                          <h4>{{$t('MT5')}}</h4>
                          <p>{{$t('winIosAndroid')}}</p>
                        </div>
                      </router-link>
                    </div>  -->
                    <div class="dpBox d-flex align-items-center">
                      <router-link to="/download-platform"> 
                        <div class="ico">
                          <img src="../../../../static/fxView/images/platforn-icon-2.svg" alt="">
                        </div>
                        <div class="desc">
                          <h4 v-html="$t('actTrader')"></h4>
                          <p> {{$t('winIosAndroid')}}</p>
                        </div>
                      </router-link>
                    </div> 
                  </div>
                </div>
              </div>
          </div> 
        </div> 
        <div class="row mt-5 mb-5" v-if="!(get_user.fresh_user || openDemoAccount)">
          <div class="col-12 text-center">
            <h3 class="bold"> {{$t('rangeTradTools')}}</h3>
          </div>
        </div>
        <div class="row" v-if="!(get_user.fresh_user || openDemoAccount) && subPlanList.totalRecords > 0">
			<div class="col-4" v-for="list in subPlanList.records" v-if="parseInt(list.id) != 4">
				<div class="glimpseBox mb-3">
					<h4 class="border-bottom pb-3 mb-3"> {{list.plan_name}}</h4>
					<p class="mb-3" v-if="parseInt(list.id) == 1">{{$t('wlcmMsz1')}}</p>
					<p class="mb-3" v-if="parseInt(list.id) == 2">{{$t('wlcmMsz2')}}</p>
					<p class="mb-3" v-if="parseInt(list.id) == 3">{{$t('wlcmMsz3')}}</p>
					<p class="mb-3" v-if="parseInt(list.id) == 5">{{$t('wlcmMsz4')}}</p>
					<p class="mb-3" v-if="parseInt(list.id) == 6">{{$t('wlcmMsz5')}} </p>
					<router-link :to="'/auto-chartist'" class="prism_btn btn_sm" title="subscribe" data-placement="top"  data-toggle="tooltip" v-if="parseInt(list.id) == 1">
						{{$t('SeeMore')}}
					</router-link>
					<router-link :to="'/signal-centre'" class="prism_btn btn_sm" title="subscribe" data-placement="top"  data-toggle="tooltip" v-if="parseInt(list.id) == 2">
						{{$t('SeeMore')}}
					</router-link>
					<router-link :to="'/trade-news'" class="prism_btn btn_sm" title="subscribe" data-placement="top"  data-toggle="tooltip" v-if="parseInt(list.id) == 3">
						{{$t('SeeMore')}}
					</router-link>
					<router-link :to="'/economic-calendar'" class="prism_btn btn_sm" title="subscribe" data-placement="top"  data-toggle="tooltip" v-if="parseInt(list.id) == 5">
						{{$t('SeeMore')}}
					</router-link>
					<router-link :to="'/vps-list'" class="prism_btn btn_sm" title="subscribe" data-placement="top"  data-toggle="tooltip" v-if="parseInt(list.id) == 6">
						{{$t('SeeMore')}}
					</router-link>
				</div>
			</div>
			<!--<div class="col-4">
				<div class="glimpseBox mb-3">
					<h4 class="border-bottom pb-3 mb-3"> {{$t('autoChart')}}</h4>
					<p class="mb-3"> {{$t('autoChartCont')}}</p>
					<a href="#" class="prism_btn darkBG btn_sm">{{$t('requestAccess')}}</a>
				</div>
			</div>
			<div class="col-4">
				<div class="glimpseBox mb-3">
					<h4 class="border-bottom pb-3 mb-3"> {{$t('signalCenter')}}</h4>
					<p class="mb-3"> {{$t('signalCenterCon')}}</p>
					<a href="#" class="prism_btn darkBG btn_sm">{{$t('requestAccess')}}</a>
				</div>
			</div>
			<div class="col-4">
              <div class="glimpseBox mb-3">
                  <h4 class="border-bottom pb-3 mb-3"> {{$t('traderToolBox')}}</h4>
                  <p class="mb-3"> {{$t('traderToolBoxCont')}}</p>
                  <a href="#" class="prism_btn darkBG btn_sm">{{$t('requestAccess')}}</a>
              </div>
          </div>
          <div class="col-4">
              <div class="glimpseBox mb-3">
                  <h4 class="border-bottom pb-3 mb-3"> {{$t('calculators')}}</h4>
                  <p class="mb-3"> {{$t('calculatorsCon')}}</p>
                  <a href="#" class="prism_btn darkBG btn_sm">{{$t('requestAccess')}}</a>
              </div>
          </div>
          
          
          <div class="col-4">
              <div class="glimpseBox mb-3">
                  <h4 class="border-bottom pb-3 mb-3"> {{$t('promotion')}}</h4>
                  <p class="mb-3"> {{$t('promotionCont')}}</p>
                  <a href="#" class="prism_btn darkBG btn_sm">{{$t('requestAccess')}}</a>
              </div>
          </div>
          <div class="col-4">
              <div class="glimpseBox mb-3">
                  <h4 class="border-bottom pb-3 mb-3"> {{$t('investInPamm')}}</h4>
                  <p class="mb-3"> {{$t('investInPammCont')}}</p>
                  <a href="#" class="prism_btn darkBG btn_sm">{{$t('requestAccess')}}</a>
              </div>
          </div>-->
        </div>
        
    </div>
</template>
<script>
  import {SET_STATE} from '@/types'
  import appregistersteps from '../registerSteps/register_steps' 
    import { fxViewMixins } from '@/plugins/fxView'
     import VueCircle from 'vue2-circle-progress'
    export default {
      name: 'Dashboard',
      mixins: [fxViewMixins],
      data() {
        return {
          demo : 0,
          live : 1,
          openDemoAccount : 0,
          setUpFxaccount: false,
		  pageLoader : false,
		  response_msg : '',
		  msg_type : '',
          userStep: 0,
          fill : { color: "#25c16f"},
          steps:['Personal Information', 'Financial Details', 'Target Market Assessment', ' Trading Experience', 'Declaration', 'Upload Personal Documents']
        }
      },
      components:{
        appRegisterSteps: appregistersteps,
        VueCircle
      },
      methods:{
        modifyStep(backto){
          let currentStep = this.get_user.step

          if('tempStep' in this.get_user && currentStep < this.get_user.tempStep){
            currentStep = this.get_user.tempStep
          }
          this.get_user.tempStep = currentStep
          this.get_user.step = backto          
          let user_json = this.get_user
          this.$store.commit(SET_STATE, user_json)
        },
        getBacktoStep(backto){
          let currentStep = this.get_user.step
          if('tempStep' in this.get_user && currentStep < this.get_user.tempStep){
            currentStep = this.get_user.tempStep
          }

          if(currentStep >= backto){
            this.get_user.tempStep = currentStep
            this.get_user.step = backto
            this.get_user.fresh_user = 1
            let user_json = this.get_user
            this.$store.commit(SET_STATE, user_json)
          }

          localStorage.setItem("demo_live",1)
          
        },

        getCurrentSteps(){
          
          let currentStep = this.get_user.step

          if('tempStep' in this.get_user && currentStep < this.get_user.tempStep){
            currentStep = this.get_user.tempStep
          }

          this.userStep = currentStep
          return currentStep
        },

        tillCompletedTask(key){
          let userActualStep = 0
          const userInfo = this.get_user
          const {tma_result} = userInfo.profile;

          if("tempStep" in userInfo){
            if(userInfo['tempStep'] < userInfo.step){
              userActualStep = userInfo.step
            }else{
              userActualStep = userInfo['tempStep']
            }
          }else{
            userActualStep = userInfo.step
          }
          if ((userActualStep === 2 || userActualStep === 3 || userActualStep === 4 || userActualStep === 5) && (tma_result === "ACCEPTED" || tma_result === "GREY_AREA_3" || tma_result === "GREY_AREA_4") && userInfo.profile.tma_enabled === "N" && !userInfo.profile.show_tma_continue && userInfo.profile.show_tma_continue !== false && !userInfo.edittedStepAfterLogin) {
            userActualStep = userInfo.step + 1
            this.goToNextStep(userActualStep);
          }

          if(key < parseInt(userActualStep)){
            return true
          }else{
            return false
          }

        },
        goToNextStep(userActualStep) {
          let user_json = this.get_user
          var user = localStorage.getItem('user')
          user = atob(user);
          user = JSON.parse(user)
          user_json.step = userActualStep;
          user.step = userActualStep;
          user_json.edittedStepAfterLogin = true;
          user.edittedStepAfterLogin = true;
          this.$store.commit(SET_STATE, user_json)
          localStorage.setItem('user', btoa(JSON.stringify(user)))
        },
      },
      computed:{
        userCstep: function(){
          let currentStep = this.get_user.step
          if('tempStep' in this.get_user && currentStep < this.get_user.tempStep){
            currentStep = this.get_user.tempStep
          }
          this.userStep = currentStep

          if(this.$refs.completeCircle){
              this.$refs.completeCircle.updateProgress(this.userStep ? this.userStep*16.67 : 0);
          }
          

          return currentStep
        },
      },
	  created(){
			this._runGetSubPlanList({'globalParams' : {} ,'localParams' : {'parameter' : this}})
		
	  }
	  
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/users/welcome.vue